<div class="generic-modal-overlay">
  <div class="generic-modal-container">
    @if (imageSrc) {
      <img [src]="imageSrc" alt="Bienvenida" class="generic-modal-img" />
    }
    <span class="generic-modal-title">{{ title }}</span>
    <span class="generic-modal-bold">
      <span class="generic-modal-bold-main">{{ boldText }}</span
      ><span class="generic-modal-desc"> {{ description }}</span>
    </span>
    @if (show2Buttons) {
      <div class="generic-modal-actions">
        <button
          class="generic-modal-btn generic-modal-btn-no"
          (click)="onClose()"
        >
          {{ noText }}
        </button>
        <button
          class="generic-modal-btn generic-modal-btn-yes"
          (click)="onConfirm()"
        >
          {{ yesText }}
        </button>
      </div>
    } @else {
      <div class="generic-modal-actions">
        <button
          class="generic-modal-btn generic-modal-btn-yes"
          (click)="onConfirm()"
        >
          {{ yesText }}
        </button>
      </div>
    }
  </div>
</div>
